import { render, staticRenderFns } from "./image-cmp.vue?vue&type=template&id=6ab341ca"
import script from "./image-cmp.vue?vue&type=script&lang=js"
export * from "./image-cmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports